// MY BESTIE ACTIVATE *****************************************************************************
// pathname: /v1/my-bestie/activate
// Activates the My Bestie service from the user's wallet balance.
// ************************************************************************************************
import { useSwrMutationApi } from '@hooks/useSwrApi';

interface UseSwrMyBestieActivateProps {
  locale: string;
  successCallback?: () => void;
  errorCallback?: () => void;
}

/**
 * @description SWR mutation: activate the My Bestie service from wallet balance.
 * - `locale` string - the locale to use for the request.
 * - `successCallback` function - called after successful activation.
 * - `errorCallback` function - called on error.
 */
export const useSwrMyBestieActivate = (props: UseSwrMyBestieActivateProps) => {
  const { locale, successCallback, errorCallback } = props;

  const {
    data, error, isMutating, reset, trigger,
  } = useSwrMutationApi<{ success: boolean }, Record<string, never>>({
    url: '/v1/my-bestie/activate',
    locale,
    fetcherConfig: {
      method: 'POST',
      stringifyPayload: true,
    },
    apiOptions: {
      onSuccess: () => {
        if (successCallback) successCallback();
      },
      onError: () => {
        if (errorCallback) errorCallback();
      },
    },
    toastsOptions: {
      showErrorToast: true,
    },
  });

  return {
    data, error, isMutating, reset, trigger,
  };
};
